import { render, staticRenderFns } from "./RecoveryTask.vue?vue&type=template&id=09506e2a&scoped=true&"
import script from "./RecoveryTask.vue?vue&type=script&lang=js&"
export * from "./RecoveryTask.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryTask.vue?vue&type=style&index=0&id=09506e2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09506e2a",
  null
  
)

export default component.exports